import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_CHILLER',
  GET: 'GET_CHILLER',
  CREATE: 'CREATE_CHILLER',
  EDIT: 'EDIT_CHILLER',
  DELETE: 'DELETE_CHILLER',
  DUPLICATE: 'DUPLICATE_CHILLER',
  CLEAR_ERROR: 'CLEAR_ERROR_CHILLER',
};

export const clearErrorChiller = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchChillerByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchChiller(pageSize, page, sorted, filtered, isPublic);
};

export const searchChiller = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_CHILLER,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listChiller = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchChiller(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getChiller = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_CHILLER}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createChiller = (name, typeId, brandId, compressorType, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type', typeId);
  formData.set('brand_id', brandId);
  formData.set('compressor_type', compressorType);
  formData.set('cooling_capacity', coolingCap);
  formData.set('unit', unitId);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `chil_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_CHILLER,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editChiller = (id, name, typeId, brandId, compressorType, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeId) formData.set('type', typeId);
  if (brandId) formData.set('brand_id', brandId);
  if (compressorType) formData.set('compressor_type', compressorType);
  if (coolingCap) formData.set('cooling_capacity', coolingCap);
  if (unitId) formData.set('unit', unitId);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `chil_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_CHILLER}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteChiller = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_CHILLER}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateChiller = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_CHILLER}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/chiller_actions.js